import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'rt-verify-email',
  imports: [
    ButtonModule
  ],
  standalone: true,
  templateUrl: './verify-email.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent {
  private dialogRef = inject(DynamicDialogRef);

  close(): void {
    this.dialogRef.close({ hasChanges: false });
  }
}
